import * as React from "react";
import { useParams } from "react-router-dom";
import {
  Typography,
  Card,
  Stack,
  Button,
  Divider,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { Loader, useAppConfig } from "../../../shared";
import InputControl from "../../../shared/components/InputControl";
import SimpleReactValidator from "simple-react-validator";
import { useOnlineOrderingSettings } from "../hooks/useOnlineOrderingSettings";

export const OnlineOrderingSettings = () => {
  const { id } = useParams();
  const { currencySymbol } = useAppConfig();
  const {
    state,
    handleInputChange,
    handleSubmit,
  } = useOnlineOrderingSettings(id);
  const { isLoading, details, isSaveButtonBusy } = state;

  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );

  const {
    status,
    fee_type,
    value,
  } = details;


  const onSubmit = () => {
    if (validator.current.allValid()) {
      handleSubmit();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {validator.current.purgeFields()}
          <Card sx={{ mb: "230px", overflow: "inherit" }}>
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                p: "24px",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="200px"
              >
                Settings
              </Typography>
              <Button
                type="button"
                size="medium"
                variant="contained"
                onClick={onSubmit}
                disabled={isSaveButtonBusy}
              >
                Save
              </Button>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="200px"
              >
                Stripe Customer Fee
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <InputControl
                  type="switch"
                  name="variance_status"
                  value={status}
                  sx={{ marginLeft: "16px" }}
                  onChange={(e) =>
                    handleInputChange({
                      target: {
                        name: "status",
                        value: e.target.checked,
                      },
                    })
                  }
                />
                {!!status && (<>
                  <Box ml="16px">
                    <RadioGroup
                      row
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="fee_type"
                      value={fee_type}
                    >
                      <FormControlLabel
                        control={<Radio />}
                        label="Percentage"
                        value='percentage'
                        onChange={(e) => handleInputChange(e)}
                      />
                      <FormControlLabel
                        value="fixed"
                        control={<Radio />}
                        label="Fixed"
                        onChange={(e) => handleInputChange(e)}
                      />
                    </RadioGroup>
                  </Box>
                  <Stack
                    sx={{
                      width: "100%",
                      gap: "16px",
                    }}
                    mt={2}
                  >
                    <Stack
                      sx={{
                        flexDirection: "row",
                        gap: "16px",
                      }}
                    >
                      <>
                        <InputControl
                          label={fee_type === 'percentage' ? "Fee Percentage (%)" : `Fee Amount (${currencySymbol})`}
                          type="number"
                          name="value"
                          onChange={(e) => {
                            let val = e.target.value;
                            // Allow only numbers with up to 2 decimal places
                            if (/^\d*\.?\d{0,2}$/.test(val)) {
                              handleInputChange({
                                target: {
                                  name: "value",
                                  value: val,
                                },
                              });
                            }
                          }}
                          value={value}
                          inputProps={fee_type === 'percentage' ? { min: 0, max: 100 } : { min: 0 }}
                          error={
                            validator.current.message(
                              fee_type === 'percentage' ? "Fee Percentage" : "Fee Amount",
                              value !== undefined && value !== null ? Number(value) : '',
                              fee_type === 'percentage' ? "required|numeric|min:0,num|max:100,num" : "required|numeric|min:0,num"
                            )
                          }
                          helperText={
                            validator.current.message(
                              fee_type === 'percentage' ? "Fee Percentage" : "Fee Amount",
                              value !== undefined && value !== null ? Number(value) : '',
                              fee_type === 'percentage' ? "required|numeric|min:0,num|max:100,num" : "required|numeric|min:0,num"
                            )
                          }
                        />
                      </>
                    </Stack>
                  </Stack>
                </>)}
              </Stack>
            </Stack>
          </Card>
        </>
      )}
    </>
  );
};
